<template>
  <div class="container mb-5 gap-150 d-flex flex-column">

    <error v-if="currentJob.state === 'failed'"></error>

    <cancelled v-if="currentJob.state === 'cancelled'"></cancelled>

    <div class="file-container" style="opacity:0.9" v-if="currentJob.state !== 'failed' && currentJob.state !=='cancelled' && currentJob.state !== 'unauthorized'">

      <div class="global-actions-container global-actions-container-top">
        <div class="d-flex gap-10">
          <div @click="selectAll" class="file-action-btn gap-10" v-bind:class="{ 'disabled': complete !== true}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5zm-9 12l-4-4l1.41-1.42L10 14.17l6.59-6.59L18 9"/>
            </svg>
            {{ "Select all" | trans }}
          </div>
          <div @click="deselectAll" class="file-action-btn gap-10" v-bind:class="{ 'disabled': complete !== true}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z"/>
            </svg>
            {{ "Select none" | trans }}
          </div>
        </div>
      </div>

      <div class="p-3 bg-white" v-if="currentJob.state === 'not_found'">
        <div class="alert alert-danger pt-4">
          <p><strong><i class="lh-inherit far fa-info-circle"></i> {{ 'Task not found'|trans }}</strong></p>
        </div>
      </div>

      <file-list-hints></file-list-hints>

      <!-- <progress-bar-uploading v-if="currentJob.state === 'uploading'"></progress-bar-uploading>
      <progress-bar-complete v-if="currentJob.state === 'uploading-completed'"></progress-bar-complete> -->

      <div class="file-item flex-column flex-md-row gap-10px" v-for="output in currentJob.apiJob?.input" v-if="complete === false && currentJob.state !== 'failed'">
        <div class="item d-inline-flex gap-10px">
          <input type="checkbox" disabled>

          <div class="thumb-small">
            <div>
              <div class="placeholder">
                <div class="animated-background"></div>
              </div>
            </div>
          </div>
          <div>
            <div class="placeholder" :style="{'min-width': getRandomInt(100, 300) + 'px'}">
              <div class="animated-background"></div>
            </div>
          </div>
        </div>
      </div>

      <file-list-outputs></file-list-outputs>
      <file-list-outputs-warning></file-list-outputs-warning>

      <div class="global-actions-container">
        <div class="d-flex gap-10">
          <div @click="selectAll" class="file-action-btn gap-10" v-bind:class="{ 'disabled': complete !== true}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5zm-9 12l-4-4l1.41-1.42L10 14.17l6.59-6.59L18 9"/>
            </svg>
            {{ 'Select all' | trans }}
          </div>
          <div @click="deselectAll" class="file-action-btn gap-10" v-bind:class="{ 'disabled': complete !== true}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor"
                    d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z"/>
            </svg>
            {{ 'Select none' | trans }}
          </div>
        </div>
      </div>
    </div>

    <warning v-if="currentJob.apiJob?.warnings.length > 0"></warning>

    <protected v-if="currentJob.state === 'unauthorized'"></protected>

    <div class="feedback-full" v-if="resultPage.isMobile === false">
      <feedback-full></feedback-full>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import PreviewManager from "../../manager/PreviewManager";
import JobManager from "../../manager/JobManager";
import OutputSelectionManager from "../../manager/OutputSelectionManager";
import DownloadManager from "../../manager/DownloadManager";
import ThumbnailManager from "../../manager/ThumbnailManager";
import Error from "../Elements/Error.vue";
import {formatting} from "../../../../../../helper/formatting";
import Analytics from "../../util/Analytics";
import { EventBus } from "../../events/event.bus";
import FeedbackFull from "../Elements/FeedbackFull.vue";
import FileListHints from "./FileList/FileListHints.vue";
import FileListOutputs from "./FileList/FileListOutputs.vue";
import FileListOutputsWarning from "./FileList/FileListOutputsWarning.vue";
import ProgressBarUploading from "./ProgressBar/ProgressBarUploading";
import ProgressBarComplete from "./ProgressBar/ProgressBarComplete";
import Warning from "../Elements/Warning.vue";
import Cancelled from '../Elements/Cancelled.vue';
import Protected from '../Elements/Protected.vue';

export default {
  name: "FileList",
  props: {},
  components: {
    Warning, 
    FileListOutputsWarning, 
    FileListOutputs, 
    FileListHints, 
    FeedbackFull, 
    ProgressBarUploading, 
    ProgressBarComplete,
    Error, 
    Protected, 
    Cancelled
  },
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      hoverOutput: {id: null},
    };
  },
  created: function () {
  },
  filters: {
    getFilenameFromUrl(url) {
      let lastSlashIndex = url.lastIndexOf('/')
      return url.substring(lastSlashIndex + 1)
    },
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }

  },
  methods: {
    imageChanged() {
    },
    mouseEnter(output) {
      if (PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output)) === true) {
        this.hoverOutput = output;
        ThumbnailManager.generateThumbnail(this.currentJob, output);
      } else {
        this.hoverOutput = {id: null}
      }
    },
    mouseOut(e) {
      this.hoverOutput = {id: null}
    },
    mouseOver(e) {
      this.mouseEnter(e);
      //let cursor = document.getElementById("preview-img");
      //cursor.style.display = 'inherit';
    },
    getReadableSize(size) {
      return formatting.fileSize(size);
    },
    isOutputSmaller(output) {
      return JobManager.isOutputSmaller(output, this.currentJob);
    },
    getCompressDiff(output) {
      return JobManager.getOutputCompressDiff(output, this.currentJob);
    },
    isCompressJob() {
      return JobManager.isCompressJob(this.currentJob);
    },
    getInputForOutput(output) {
      let input = JobManager.getInputByOutputSource(output, this.currentJob);
      return input[0];
    },
    getThumbnailForOutput(output) {
      return ThumbnailManager.getSmallThumbnailByOutput(this.currentJob, output);
    },
    isSmallThumbnailByOutputLoading(output) {
      return ThumbnailManager.isSmallThumbnailByOutputLoading(this.currentJob, output);
    },
    generateThumbnail(output) {
      ThumbnailManager.generateThumbnail(this.currentJob, output);
    },
    download(output) {
      DownloadManager.downloadOutput(output, this.currentJob);
    },
    selectAll() {
      Analytics.send('result_action', 'select_all', this.currentJob);

      OutputSelectionManager.selectAll(this.currentJob);
    },
    deselectAll() {
      Analytics.send('result_action', 'deselect_all', this.currentJob);

      OutputSelectionManager.deselectAll(this.currentJob);
    },
    isSelected(output) {
      return OutputSelectionManager.isOutputSelected(this.currentJob, output);
    },
    toggleSelection(output) {
      OutputSelectionManager.toggleOutput(this.currentJob, output)
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
    },
    openPreview(output) {
      if (this.canPreview(output) === false) {
        return;
      }

      $('[data-toggle="tooltip"]').tooltip('hide');
      PreviewManager.openPreview(this.currentJob, output);
    },
    canPreview(output) {
      return PreviewManager.canPreview(JobManager.getExtensionFromOutput(output));
    },
    canPreviewMini(output) {
      return PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output));
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.short-text-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.gap-10px {
  gap: 10px;
}

.filename-cursor {
  pointer-events: inherit;
  cursor: pointer;
}

.bg-selected {
  background: #f8f8ff !important;
  border-bottom: 1px solid #D9E7FD !important;
}

.thumb-small {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  z-index: 10;
  overflow: hidden;

  &.no-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #6C757D;
    cursor: inherit;
  }

  img {
    object-fit: cover;
    width: 50px;
    height: 50px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }
}

.thumb-preview {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 150px;
  height: auto;
  position: absolute;
  right: -170px;
  top: -55px;
  padding: 5px;
  z-index: 10;

  img {
    z-index: 100;
    border-radius: 0px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  &:before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 45px;
    left: -10px;
    height: 20px;
    width: 20px;
    background: white;
    transform: rotate(45deg);
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
}

.placeholder {
  margin: 0;
  width: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 4px !important;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
  top: 0;
}


#preview-img {
  transition: width 2s, height 4s;
  background: white;
  border: 1px solid #ccc;
  display: none;
  width: 100px;
  height: auto;
  z-index: 1000;
  padding: 5px;
  position: absolute;
  max-height: 300px;
  overflow: hidden;
}

.line-through {
  text-decoration: line-through;
}

.spinner-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;

  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}

.global-actions-container-top {
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    border-bottom: 1px solid #595959;
  }
}

.global-actions-container {
  padding: 10px;

  .dark-mode & {
    background: #272727;
    color: white;
  }
}

.feedback-full {
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}

.file-container {
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  width: 100%;
  background: #FBFBFB;

  .dark-mode & {
    border: 1px solid #595959;
  }
}

.file-actions {
  gap: 10px;
}

.file-item {
  .item {
    display: flex;
    align-items: center;
  }

  vertical-align: center;
  padding: 10px;
  display: flex;
  gap: 5px;
  background: white;
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.download-btn {
  cursor: pointer;
  background: #1266F1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.upload-btn {
  cursor: pointer;

  i {
    line-height: inherit;
  }

  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.file-action-btn {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}

.compress-success {
  background: #CCF4DC;
  color: #0B7335;
  border: 1px solid #0B7335;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.compress-failed {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: #6C757D;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.placeholder {
  margin: 0 auto;
  max-width: 400px;
  min-height: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 4px;
  opacity: .6;
  background-color: #eee;
  transition: all 1s;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100px;
  position: relative;
}
</style>
